import React, { useEffect, useState, useRef } from "react";
import Headers from "@/components/Headers";
import { Split } from "@/constants/breadcrumb";
import Search from "./Search"; 
import Content from "./Content";
import { shareCompanyList } from "@/api/business";
import { message } from "antd";
import "./index.scss";

const SplitPage = () => { 

  const containerRef = useRef(null);

  const [otherParams,setOtherParams]=useState({}); 

  const [dataSource, setDataSource] = useState([]);

  const [page, setPage] = useState({
    pageNum: 1,
    pageSize: 10,
    total: 0,
  });

  const fetchList = () => {
    shareCompanyList({
      pageNum: page.pageNum,
      pageSize: page.pageSize,
      ...otherParams
    }).then((res) => {
      if (res.success) {
        setDataSource(res.data.list);
        setPage({ ...page, total: res.data.total });
      }
    });
  };
  useEffect(() => {
    fetchList();
  }, [page.pageSize, page.pageNum,otherParams]);

  const handleTableChange = (pageNum, pageSize) => {
    setPage({ ...page, pageNum, pageSize });
  };

  const handleShowSizeChange = (pageNum, pageSize) => {
    setPage({ ...page, pageNum: 1, pageSize });
  }; 

  const handleSearch=(values)=>{
    setOtherParams({...values})
    setPage({ ...page, pageNum: 1 });
  }

  return (
    <div className="container business-page" ref={containerRef}>
      <Headers BreadCrumbData={Split}></Headers>

      <Search  onSearch={handleSearch} /> 

      <Content
        dataSource={dataSource}
        page={page}
        onTableChange={handleTableChange}
        onShowSizeChange={handleShowSizeChange} 
      />
    </div>
  );
};
export default SplitPage;
